import PropTypes from "prop-types";
import React from "react";
import { Link, withRouter } from "react-router-dom";
import ReactRouterPropTypes from "react-router-prop-types";

import Loader from "../../shared/components/Loader";
import ServicesListFilter from "../containers/ServicesListFilter";
import ServicesListGroup from "../containers/ServicesListGroup";
import { ProductShape, ServiceShape } from "../proptypes";

const ServicesList = ({
  services,
  products,
  hasFilter,
  canEdit,
  productsSelectable,
  loading,
  location
}) => {
  const serviceGroups = loading ? (
    <Loader text="Loading services..." />
  ) : (
    products.map(product => {
      const serviceItems = services.filter(
        service => service.product.$ref === product.$uri
      );

      if (serviceItems.length) {
        return (
          <ServicesListGroup
            product={product}
            productSelectable={productsSelectable}
            services={serviceItems}
            key={product.$uri}
          />
        );
      }
      return undefined;
    })
  );

  const { pathname } = location;
  return (
    <div className="l-policies__column" style={{ gridArea: "services" }}>
      <div className="l-policies__column-header">
        <div>
          {pathname === "/policies" ? (
            <Link
              to="/policies/services"
              className="p-button--link p-muted-heading"
            >
              Services
            </Link>
          ) : (
            <span
              className="p-muted-heading u-no-margin--bottom"
              style={{ marginRight: "1rem" }}
            >
              Services
            </span>
          )}
          {pathname === "/policies" && canEdit && (
            <Link
              to="/policies/services/add"
              className="p-button p-button--thin"
              data-role="add-service-button"
            >
              <span>
                <i className="p-icon--plus" />
                <span className="p-icon__text">Add</span>
              </span>
            </Link>
          )}
        </div>
      </div>
      <div className="l-policies__column-panel">
        {hasFilter && <ServicesListFilter />}
        <ul className="p-list">{serviceGroups}</ul>
      </div>
    </div>
  );
};

ServicesList.propTypes = {
  services: PropTypes.arrayOf(ServiceShape).isRequired,
  products: PropTypes.arrayOf(ProductShape).isRequired,
  loading: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool.isRequired,
  productsSelectable: PropTypes.bool,
  hasFilter: PropTypes.bool,
  location: ReactRouterPropTypes.location.isRequired
};

ServicesList.defaultProps = {
  productsSelectable: true,
  hasFilter: false
};

export default withRouter(ServicesList);
